function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.primary-6{fill:none;}.white{fill:#fff;}.highlights-8{fill:#e8dbec;}.primary-6{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("polygon", {
  className: "white",
  points: "208 24 208 232 48 232 48 76.21 95.46 24 208 24"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("path", {
  className: "highlights-8",
  d: "M169.51,93.81A29,29,0,0,1,133.72,139l-27.41,27.41v11.32H95V189l-16.7-5.39L78,172l45-44.94a29,29,0,0,1,46.54-33.28Z"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("polygon", {
  className: "primary-6",
  points: "208 24 208 232 48 232 48 76.21 95.46 24 208 24"
}), React.createElement("polygon", {
  className: "primary-6",
  points: "98.91 24 51.45 76.21 98.91 76.21 98.91 24"
}), React.createElement("path", {
  className: "primary-6",
  d: "M169.51,93.81A29,29,0,0,1,133.72,139l-27.41,27.41v11.32H95V189l-16.7-5.39L78,172l45-44.94a29,29,0,0,1,46.54-33.28Z"
}), React.createElement("line", {
  className: "primary-6",
  x1: 151.56,
  y1: 109.8,
  x2: 151.56,
  y2: 109.8
})));
var SvgMarketingKeyword = function SvgMarketingKeyword(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarketingKeyword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MarketingKeyword.29c67fd9.svg";
export { ForwardRef as ReactComponent };